export default "/download-on-the-app-store.svg";